<template>
  <div class="col-md-12 p-0 contract-create-page">
    <!-- popup shift wark -->
    <div class="popup popup-sm contract-create-modal contract-create-modal--shift" v-if="isEnablePopup == 'shiftwork'">
      <div class="content">
        <h5>
          Shift Worker <br /><small class="text-secondary"
            >Set shift name, start hour, and working hours, then click "Add New" to
            generate new shift work</small
          >
        </h5>
        <hr />
        <div class="row p-0 mt-5">
          <div class="col-md-3 p-0">
            <div class="form-group">
              <label>Shift Name</label><br />
              <select class="form-control" v-model="sw.name">
                <option value="">-- Choose One --</option>
                <option value="pagi" :disabled="isShiftNameUsed('pagi')">Pagi</option>
                <option value="pagi 2" :disabled="isShiftNameUsed('pagi 2')">pagi 2</option>
                <option value="pagi 3" :disabled="isShiftNameUsed('pagi 3')">pagi 3</option>
                <option value="siang" :disabled="isShiftNameUsed('siang')">Siang</option>
                <option value="malam" :disabled="isShiftNameUsed('malam')">Malam</option>
                <option value="malam 2" :disabled="isShiftNameUsed('malam 2')">malam 2</option>
                <option value="malam 3" :disabled="isShiftNameUsed('malam 3')">malam 3</option>
                <option value="middle" :disabled="isShiftNameUsed('middle')">Middle</option>
              </select>
              <!-- <input
                type="text"
                class="form-control"
                v-model="sw.name"
                placeholder="..."
              /> -->
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="form-group">
              <label>Start Shift Hour </label><br />
              <input
                type="time"
                class="form-control"
                v-model="sw.hour"
                placeholder="..."
              />
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="form-group">
              <label>Working Hours</label><br />
              <select class="form-control" v-model.number="sw.working_hours">
                <option v-for="hour in workingHoursOptions" :key="hour" :value="hour">
                  {{ hour }} Hours
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="form-group">
              <br />
              <a
                href="javascript:;"
                class="btn btn-secondary"
                @click="AddShiftWork()"
                >Add New</a
              >
            </div>
          </div>
        </div>
        <hr />
        <div class="row p-0">
          <div class="col-md-9">
            <span class="text-danger" v-if="this.sw.msg_error !== ''">{{
              this.sw.msg_error
            }}</span
            ><br />
            <div
              class="list-data"
              v-for="(items, idx) in this.sw.data"
              :key="idx"
            >
              - {{ items.name }} ({{ items.hour }}) ·
              <select class="shift-hours-select" v-model.number="items.working_hours">
                <option v-for="hour in workingHoursOptions" :key="hour" :value="hour">{{ hour }} hours</option>
              </select>
              <i
                class="ti ti-trash text-danger"
                @click="RemoveShiftWorker(idx)"
              ></i>
            </div>
          </div>
        </div>
        <hr />
        <div class="row p-0 mb-5">
          <div class="col-md-12">
            <a
              href="javascript:;"
              class="btn btn-primary float-right"
              @click="isEnablePopup = false"
              >Finish & Close</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- popup man power -->
    <div class="popup popup-sm contract-create-modal contract-create-modal--compact" v-if="isEnablePopup == 'manpower'">
      <div class="content">
        <small id="close-popup" @click="isEnablePopup = false"
          ><i class="ti ti-close"></i
        ></small>
        <h5>
          Generate Man Power <br /><small class="text-secondary"
            >Click button "Add New" to generate new man power</small
          >
        </h5>
        <hr />
        <div class="row p-0">
          <div class="col-md-2 p-0">
            <div class="form-group">
              <label>Total</label><br />
              <input
                type="number"
                min="1"
                class="form-control"
                placeholder="0"
                v-model="mp.total"
              />
            </div>
          </div>
          <div class="col-md-7 p-0">
            <div class="form-group">
              <label>Job Position</label><br />
              <select class="form-control" v-model="mp.job">
                <option value="">-- Choose One --</option>
                <option v-for="(items, idx) in model_jobpos" :key="idx">
                  {{ items.title }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="form-group">
              <br />
              <a
                href="javascript:;"
                class="btn btn-secondary"
                @click="AddMoreManPower()"
                >Add New</a
              >
            </div>
          </div>
        </div>
        <div class="row p-0 mb-5">
          <div class="col-md-11">
            <span class="text-danger" v-if="this.mp.msg_error !== ''">{{
              this.mp.msg_error
            }}</span
            ><br />
            <h5></h5>
            <div
              class="list-data"
              v-for="(items, idx) in this.mp.data"
              :key="idx"
            >
              - {{ items.total }} ( {{ items.job }} )
              <i
                class="ti ti-trash text-danger"
                @click="RemoveManPower(idx)"
              ></i>
            </div>
          </div>
        </div>

        <hr />
        <div class="row p-0 mb-5">
          <div class="col-md-12">
            <a
              href="javascript:;"
              class="btn btn-primary float-right"
              @click="isEnablePopup = false"
              >Finish & Close</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- popup section room  -->
    <div class="popup popup-md contract-create-modal contract-create-modal--section" v-if="isEnablePopup == 'section'">
      <div class="content">
        <small id="close-popup" @click="isEnablePopup = false"
          ><i class="ti ti-close"></i
        ></small>
        <h5>
          Section & Room <br /><small>Section Room Creator</small>
          <hr />
        </h5>
        <div class="row p-0">
          <div class="col-md-6">
            <span>Category </span>
            <select class="form-control" v-model="category_type">
              <option value="non_cleaning">Non Cleaning</option>
              <option value="cleaning">Cleaning</option>
            </select>
          </div>
          <div class="col-md-6">
            <span class="text-success float-left" id="add-more-notify"
              >1 slot unit is already created.</span
            >
            <a
              href="javascript:;"
              class="float-right btn btn-execute mb-5"
              @click="AddMoreSlotRoom()"
            >
              <i class="ti ti-plus text-success"></i> Add More Room</a
            >
            <br />
          </div>
        </div>
        <div
          v-for="(items, idx) in data_section"
          :key="idx"
          v-if="items.section == no_section && popup_mode == 'insert'"
        >
          <div
            class="row"
            style="margin-bottom: 22px"
            v-for="(items, idx) in items.data"
            :key="idx"
          >
            <div class="col-md-4">
              <span>Floor</span>
              <input
                type="number"
                min="1"
                class="form-control"
                placeholder="1"
                v-model="items.area_floor"
              />
            </div>
            <div class="col-md-4">
              <span>Area Type </span>
              <select class="form-control" v-model="items.area_type">
                <option value="indoor">InDoor</option>
                <option value="outdoor">Outdoor</option>
              </select>
            </div>
            <div class="col-md-4">
              <span>Area Name</span>
              <input
                type="text"
                class="form-control"
                placeholder="...."
                v-model="items.area_name"
              />
            </div>
            <div class="col-md-12 mt-2">
              <span>Area Job Description</span>
              <textarea
                class="form-control"
                rows="3"
                placeholder="........"
                v-model="items.area_task"
              ></textarea>
            </div>
            <hr />
          </div>
        </div>
        <div
          class="row"
          style="margin-bottom: 22px"
          v-for="(items, idx) in data_section"
          :key="idx"
          v-if="items.section == active_edit_section && popup_mode == 'edit'"
        >
          <div v-for="(items, idx) in items.data" :key="idx">
            <div class="col-md-4">
              <span>Floor</span>
              <input
                type="number"
                min="1"
                class="form-control"
                placeholder="1"
                v-model="items.area_floor"
              />
            </div>
            <div class="col-md-4">
              <span>Area Type </span>
              <select class="form-control" v-model="items.area_type">
                <option value="indoor">InDoor</option>
                <option value="outdoor">Outdoor</option>
              </select>
            </div>
            <div class="col-md-4">
              <span>Area Name</span>
              <input
                type="text"
                class="form-control"
                placeholder="...."
                v-model="items.area_name"
              />
            </div>
            <div class="col-md-12 mt-4">
              <span class="text-secondary">Area Job Description</span>
              <textarea
                class="form-control"
                rows="3"
                placeholder="........"
                v-model="items.area_task"
              ></textarea>
              <hr />
            </div>
            <hr />
          </div>
        </div>
        <div class="row p-0">
          <div class="col-md-12 mt-4 text-center">
            <a
              href="javascript:;"
              class="btn btn-primary"
              @click="SaveSectionRoom()"
              >{{
                popup_mode == "insert"
                  ? "Continue Add Section"
                  : "Update Section"
              }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- popup client  -->
    <PopupClientMaster
      class="contract-create-modal contract-create-modal--client"
      v-on:exit="closeClient"
      v-on:applyData="applyClient"
      :id_branch="model.id_branch"
      v-if="isEnablePopup == 'client'"
    />
    <div class="contract-create-hero">
      <div>
        <small>CONTRACT MANAGEMENT</small>
        <h3>Create New Contract</h3>
        <p>Complete contract, client, workforce, shift, and station area information.</p>
      </div>
      <div class="contract-create-hero-icon" aria-hidden="true">
        <i class="ti ti-clipboard"></i>
      </div>
    </div>
    <form class="form-horizontal contract-create-form" @submit="submit">
      <div class="card contract-create-card">
        <div class="card-body">
          <div class="form-group contract-section-heading">
            <div class="col-sm-12">
              <label class="text-primary mb-0"
                ><i class="ti ti-info-alt"></i> Detail Information
                Contract</label
              >
              <small class="text-secondary"
                >Please fill completely detail data.</small
              >
              <hr />
            </div>
          </div>
          <div class="form-group" v-if="isEnableSelectBranch">
            <label class="col-sm-3"
              >Branch Station <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <SelectBranch
                v-on:processBranch="processBranch"
                :title="'disable'"
              />
              <small class="text-danger" v-if="msg_error.id_branch">{{
                msg_error.id_branch[0]
              }}</small>
            </div>
          </div>
          <div class="form-group" v-else>
            <label class="col-sm-3"
              >Branch Station <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-model="branch_name"
                readonly
              />
              <small class="text-danger" v-if="msg_error.id_branch">{{
                msg_error.id_branch[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Number of Contract <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <!-- Old Version -->
              <input
                type="text"
                class="form-control"
                placeholder="...."
                v-model="model.contract_number"
              />

              <!-- New Version (Disable) -->
              <!-- <multiselect
                v-model="selected_contract"
                :options="contract_list"
                label="contract_number"
                track-by="contract_id"
                placeholder="-- Choose Contract --"
                @select="onSelectContract"
              >
                
                <template #option="{ option }">
                  <div>
                    {{ option.contract_number }} - {{ option.client_name }}
                    <span v-if="option.is_used">(Used)</span>
                  </div>
                </template>

                <template #singleLabel="{ option }">
                  <div>
                    {{ option.contract_number }} - {{ option.client_name }}
                  </div>
                </template>
              </multiselect>

              <small class="text-danger" v-if="msg_error.contract_number">
                {{ msg_error.contract_number[0] }}
              </small>

              <div
                v-if="selected_contract_number"
                class="contract-info-box mt-3"
              >
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <strong class="text-primary">
                      <i class="ti ti-user"></i> Client Information (From
                      Contract No # {{ selected_contract_number }})
                    </strong>
                  </div>

                  <div class="col-md-6">
                    <div class="info-item">
                      <label>Client Name</label>
                      <div class="value">
                        {{ model.clientName }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="info-item">
                      <label>Email</label>
                      <div class="value">
                        {{ model.clientEmail || "-" }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 mt-2">
                    <div class="info-item">
                      <label>Phone</label>
                      <div class="value">
                        {{ model.clientPhoneNumber || "-" }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 mt-2">
                    <div class="info-item">
                      <label>Address</label>
                      <div class="value">
                        {{ model.clientAddress || "-" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- End New Version (Disable) -->
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Contract Value (Amount)
              <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <vue-numeric
                separator="."
                output-type="String"
                currency="Rp"
                v-model="model.contract_value"
                class="form-control"
              ></vue-numeric>
              <small class="text-danger" v-if="msg_error.contract_value">{{
                msg_error.contract_value[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Contract Date <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <date-picker
                style="width: 100%"
                v-model="sdate"
                :clearable="false"
                value-type="format"
                type="date"
                confirm
              ></date-picker>
              <small class="text-danger" v-if="msg_error.contract_date">{{
                msg_error.contract_date[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Contract Period <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <date-picker
                style="width: 100%"
                v-model="filter_date"
                :clearable="false"
                value-type="format"
                type="date"
                placeholder="Pilih Range Tanggal"
                @change="FilterModelDate()"
                confirm
                range
              ></date-picker>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3">Need Feedback</label>
            <div class="col-sm-9">
              <div class="form-check mt-2">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="model.need_feedback"
                  :true-value="1"
                  :false-value="0"
                  id="need_feedback"
                />
                <label class="form-check-label" for="need_feedback">
                  Aktifkan agar klien mengisi feedback setelah layanan selesai
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3">Contract Description</label>
            <div class="col-sm-9">
              <small class="text-secondary"
                >Fill in the description fields as needed</small
              >
              <textarea
                class="form-control"
                rows="3"
                v-model="model.description"
              ></textarea>
              <small class="text-danger" v-if="msg_error.description">{{
                msg_error.description[0]
              }}</small>
            </div>
          </div>

          <div class="form-group contract-section-heading">
            <div class="col-sm-12">
              <label class="text-primary mb-0"
                ><i class="ti ti-info-alt"></i> Detail Information Client</label
              >
              <small class="text-secondary"
                >Please fill completely detail data.</small
              >
              <hr />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Client Base <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <select
                v-model="isBaseClient"
                class="form-control"
                @change="switchClientBase()"
              >
                <option value="new">New Client</option>
                <option value="old">Take From Resource Client</option>
              </select>
            </div>
          </div>
          <div class="form-group" v-if="isBaseClient == 'old'">
            <label class="col-sm-3"></label>
            <div class="col-sm-9">
              <a
                href="javascript:;"
                class="btn btn-execute"
                @click="openClientBrowser()"
                ><i class="ti ti-server text-primary"></i>&nbsp; Browse Client
                ...</a
              >
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Client Name <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                placeholder="...."
                v-model="model.name"
                :readonly="isBaseClient == 'old' ? true : false"
              />
              <small class="text-danger" v-if="msg_error.name">{{
                msg_error.name[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Email Address <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="email"
                class="form-control"
                placeholder="...."
                v-model="model.email"
                :readonly="isBaseClient == 'old' ? true : false"
              />
              <small class="text-danger" v-if="msg_error.email">{{
                msg_error.email[0]
              }}</small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3"
              >Phone Number <small class="text-danger">*</small></label
            >

            <!-- :class="{ valid: isValidPhoneNumber, invalid: !isValidPhoneNumber }" -->
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                placeholder="...."
                v-model="model.phone_number"
                :readonly="isBaseClient == 'old' ? true : false"
                @keypress="onlyNumber"
                @keyup="removeLeadingZero"
              />
              <small class="text-danger" v-if="msg_error.phone_number">{{
                msg_error.phone_number[0]
              }}</small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3"
              >Client Address <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-model="provinces_name"
                readonly
              />
              <small class="text-danger" v-if="msg_error.id_propinsi">{{
                msg_error.id_propinsi[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"></label>
            <div class="col-sm-9">
              <select
                v-model="model.id_kota"
                class="form-control"
                :disabled="model_kota.length > 0 ? false : true"
                :readonly="isBaseClient == 'old' ? true : false"
                @change="resetAddressForSelectedCity()"
              >
                <option disabled value="">-- Pilih Kabupaten --</option>
                <option
                  v-for="(items, idx) in model_kota"
                  :value="items.id"
                  :key="idx"
                >
                  {{ items.name ? items.name : items.nama_kota }}
                </option>
              </select>
              <small class="text-danger" v-if="msg_error.id_kota">{{
                msg_error.id_kota[0]
              }}</small>
            </div>
          </div>
          <div class="form-group contract-map-row">
            <label class="col-sm-3"></label>
            <div class="col-sm-9">
              <Gmap
                name="example"
                :default_model="markerCoordinates"
                :location_bias="clientLocationBias"
                @locationChanged="applyMapLocation"
                v-if="isAutoloadMaps"
              ></Gmap>
              <small class="text-danger" v-if="msg_error.office_address">{{
                msg_error.office_address[0]
              }}</small>
              <small class="text-danger" v-if="msg_error.lat">{{
                msg_error.lat[0]
              }}</small>
              <small class="text-danger" v-if="msg_error.lng">{{
                msg_error.lng[0]
              }}</small>
            </div>
          </div>

          <!-- <div class="form-group">
            <div class="col-sm-12">
              <hr />
              <label class="text-primary mb-0"
                ><i class="ti ti-info-alt"></i> Man Power</labelPending Monitoring 
              >
              <small class="text-secondary"
                >Describe contract shift work for employee.</small
              >
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <hr />
              <label class="text-primary"
                ><i class="ti ti-info-alt"></i> Contract Shift Work</label
              >
            </div>
          </div> -->

          <div class="form-group contract-section-heading contract-area-heading">
            <div class="col-sm-12">
              <label class="text-primary mb-0"
                ><i class="ti ti-info-alt"></i> Client Station Area Base</label
              >
              <small class="text-secondary">Describe station area base.</small>

              <hr />
            </div>

            <div class="mt-2 contract-config-row">
              <div class="col-sm-3">
                Request Man Power
                <span class="badge badge-primary">{{
                  this.mp.data.length
                }}</span
                ><br />
                <small class="text-secondary"
                  >Setting Total Man Power and Job Position on Contract
                </small>
              </div>
              <div class="col-sm-9">
                <a
                  href="javascript:;"
                  class="btn btn-light mb-1"
                  @click="OpenDialog('manpower')"
                  ><i class="ti ti-plus text-success"></i> Manage Man Power
                  ...</a
                >
                <br />
                <div class="mt-3" v-if="this.mp.data.length > 0">
                  <div
                    class="list-section"
                    v-for="(items, idx) in this.mp.data"
                    :key="idx"
                  >
                    - {{ items.total }} ( {{ items.job }} )
                  </div>
                </div>
                <small class="text-danger" v-if="msg_error.man_power">{{
                  msg_error.man_power[0]
                }}</small>
              </div>
            </div>

            <div class="mt-5 contract-config-row">
              <div class="col-sm-3">
                Total Shift Work :
                <span class="badge badge-primary">{{
                  this.sw.data.length
                }}</span>
                <br />
                <small class="text-secondary"
                  >Add more area to listing your unit.
                </small>
              </div>
              <div class="col-sm-9">
                <a
                  href="javascript:;"
                  class="btn btn-light mb-1"
                  @click="OpenDialog('shiftwork')"
                  ><i class="ti ti-plus text-success"></i> Manage Shift Work
                  ...</a
                >
                <br />
                <div class="mt-3" v-if="this.sw.data.length > 0">
                  <div
                    class="list-section"
                    v-for="(items, idx) in this.sw.data"
                    :key="idx"
                  >
                    - {{ items.name }} ( {{ items.hour }} )
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-5 contract-config-row contract-area-config">
              <div class="col-sm-3">
                Total Area :
                <span class="badge badge-primary">{{
                  data_section.length
                }}</span
                ><br />
                <small class="text-secondary"
                  >Add more area to listing your unit.
                </small>
              </div>
              <div class="col-sm-9">
                <a
                  href="javascript:;"
                  class="btn btn-light mb-1"
                  @click="AddMoreSection()"
                  ><i class="ti ti-plus text-success"></i> Manage New Section
                  ...</a
                >
                <br />
              </div>

              <div
                class="row mt-3"
                v-for="(items_parent, index_parent) in data_section"
                :key="index_parent"
              >
                <div class="col-sm-3"></div>
                <div class="col-md-8">
                  <h5>
                    SECTION #{{ index_parent + 1 }}
                    <span
                      class="badge ml-2"
                      :class="
                        items_parent.category_type == 'cleaning'
                          ? 'badge-success'
                          : 'badge-secondary'
                      "
                    >
                      {{
                        items_parent.category_type == "cleaning"
                          ? "Cleaning"
                          : "Non Cleaning"
                      }}
                    </span>
                    <a
                      href="javascript:;"
                      class="float-right ml-3"
                      @click="EditSection(items_parent.section)"
                      ><i class="ti ti-pencil text-primary"></i
                    ></a>
                    &nbsp;<span class="text-light">|</span> &nbsp;
                    <a
                      href="javascript:;"
                      class="float-right"
                      @click="DeleteSection(index_parent)"
                      ><i class="ti ti-trash text-danger"></i
                    ></a>
                  </h5>
                  <div
                    v-for="(items, idx) in items_parent.data"
                    :key="idx"
                    :class="'form-group mt-2 initial-section'"
                  >
                    <div class="list-section">
                      {{ idx + 1 }} - Floor({{ items.area_floor }}),
                      {{ items.area_type }} - {{ items.area_name }}, Job Task
                      ({{ items.area_taks == null ? "..." : items.area_taks }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row contract-create-actions">
        <div class="col-md-12 text-right">
          <a
            href="javascript:;"
            class="btn btn-secondary mr-3"
            @click="$router.go(-1)"
            >Cancel</a
          >
          <button type="submit" class="btn btn-primary btn-full-screen">
            <i class="ti ti-save"></i> Save Contract
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import $ from "jquery";
import Gmap from "../../../services/Gmap";
import PopupClientMaster from "../../ClientBase/Master/@PopupClientMaster";
import SelectBranch from "../../Branch/@SelectBranch";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";

export default {
  components: {
    Gmap,
    PopupClientMaster,
    SelectBranch,
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      meta_url: "contract",
      isAutoloadMaps: true,
      isBaseClient: "new",
      isEnablePopup: false,
      isEnableSelectBranch: false,
      contract_list: [],
      selected_contract: null,
      selected_contract_number: "",
      sdate: new Date(Date.now() + 0 * 24 * 3600 * 1000)
        .toISOString()
        .slice(0, 10),
      workingHoursOptions: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      model: { name: "", id_kota: "", need_feedback: 0, working_hours: 8 },
      model_kota: [],
      markerCoordinates: [],
      filter_date: null,
      popup_mode: "insert",
      data_store: [],
      no_section: 0,
      active_edit_section: 1,
      category_type: "cleaning",
      data_section: [],
      data_slot: [],
      data_shift: [],
      mp: { total: 1, job: "", msg_error: "", data: [] },
      sw: { name: "", hour: "", working_hours: 8, msg_error: "", data: [] },
      model_jobpos: [],
      meta_filter: { id_branch: "" },
      provinces_name: "",
      branch_name: "",
      isValidPhoneNumber: true,
    };
  },
  computed: {
    ...mapState("crud", {
      msg_error: (state) => state.error,
    }),
    clientLocationBias() {
      const selectedCity = this.model_kota.find(
        (city) => String(city.id) === String(this.model.id_kota)
      );
      return {
        city: selectedCity
          ? selectedCity.name || selectedCity.nama_kota || ""
          : "",
        province: this.provinces_name || "",
        country: "Indonesia",
      };
    },
  },
  created() {
    if (localStorage.getItem("userPrivilegesName") == "root") {
      this.isEnableSelectBranch = true;
    } else {
      this.model.id_branch = localStorage.getItem("userBranchId");
      this.branch_name = localStorage.getItem("userBranchName");
      const branchCode = localStorage.getItem("userBranchCode");
      this.fetchContracts(branchCode);
    }

    this.model.id_propinsi = localStorage.getItem("id_provinces");
    this.provinces_name = localStorage.getItem("provinces_name");
  },
  mounted() {
    this.fetchKota();
    this.QueryJobPosition();
  },
  methods: {
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    removeLeadingZero() {
      if (parseInt(this.model.phone_number, 10)) {
        let phone_number = parseInt(this.model.phone_number, 10);
        this.model.phone_number = phone_number;
      }
    },
    FilterModelDate() {
      this.model.start_date = this.filter_date[0];
      this.model.end_date = this.filter_date[1];
    },
    OpenDialog(initial) {
      window.scrollTo(500, 0);
      this.isEnablePopup = initial;
    },
    async processBranch(data) {
      this.model.id_branch = data;
      this.resetContract();
      this.resetClientLocation();
      if (!data || data === "all") {
        this.provinces_name = "";
        this.model.id_propinsi = "";
        this.model.id_kota = "";
        this.model_kota = [];
        return;
      }
      await this.QueryBranch(data);
    },
    async QueryBranch(branchId) {
      try {
        const response = await axios.get("branch/find/" + branchId);
        const branch = response.data || {};

        this.model.id_propinsi = branch.id_provinces || "";
        await this.loadProvinceName(branch.id_provinces);
        this.model.id_kota = "";
        await this.fetchKotaByBranch(branch);

        if (branch.branch_code) {
          this.fetchContracts(branch.branch_code);
        }
      } catch (error) {
        this.provinces_name = "";
        this.model.id_propinsi = "";
        this.model.id_kota = "";
        this.model_kota = [];
        console.log("error fetch branch detail", error);
      }
    },
    async loadProvinceName(idProvince) {
      if (!idProvince) {
        this.provinces_name = "";
        return;
      }

      const response = await axios.post("location/propinsi/data", {
        where: { key: "id", value: idProvince },
      });
      const province = response.data && response.data[0];
      this.provinces_name = province ? province.nama_provinsi : "";
    },
    resetClientLocation() {
      this.isAutoloadMaps = false;
      this.model.id_client = "";
      this.model.name = "";
      this.model.email = "";
      this.model.phone_number = "";
      this.model.id_kota = "";
      this.model.lat = "";
      this.model.lng = "";
      this.model.office_address = "";
      this.markerCoordinates = {};
      setTimeout(() => {
        this.isAutoloadMaps = true;
      }, 200);
    },
    resetAddressForSelectedCity() {
      if (this.isBaseClient === "old") return;
      this.isAutoloadMaps = false;
      this.model.lat = "";
      this.model.lng = "";
      this.model.office_address = "";
      this.markerCoordinates = {};
      setTimeout(() => {
        this.isAutoloadMaps = true;
      }, 200);
    },
    applyMapLocation(location) {
      this.model.office_address = location.address || "";
      this.model.lat = location.latitude;
      this.model.lng = location.longitude;
    },
    async fetchKotaByBranch(branch) {
      if (
        branch.applying_regencies === "selected-area" &&
        branch.group_regencies
      ) {
        try {
          const selectedCities =
            typeof branch.group_regencies === "string"
              ? JSON.parse(branch.group_regencies)
              : branch.group_regencies;
          this.model_kota = Array.isArray(selectedCities) ? selectedCities : [];
          return;
        } catch (error) {
          console.log("error parse branch regencies", error);
        }
      }

      if (!branch.id_provinces) {
        this.model_kota = [];
        return;
      }

      const response = await axios.post("location/kota/data", {
        where: { key: "provinsi_id", value: branch.id_provinces },
        order: { key: "id", value: "asc" },
      });
      this.model_kota = response.data || [];
    },
    async fetchContracts(branchCode) {
      // if (!this.model.id_branch) return;

      try {
        let res = await axios.get("/contract/invoice-contracts", {
          params: {
            branch_code: branchCode,
          },
        });

        let contracts = res.data.data || [];

        // 🔥 mapping + handle used
        this.contract_list = contracts.map((item) => {
          return {
            ...item,
            is_used: false, // nanti bisa dari backend / logic sendiri
          };
        });
      } catch (err) {
        console.log("error fetch contract", err);
      }
    },
    resetContract() {
      this.selected_contract = null;
      this.selected_contract_number = "";

      this.model.invoice_contract_id = null;
      this.model.contract_number = "";
      this.model.contract_value = 0;

      this.model.clientName = "";
      this.model.clientEmail = "";
      this.model.clientPhoneNumber = "";
      this.model.clientAddress = "";

      this.filter_date = [];

      // optional kalau ada
      this.FilterModelDate();
    },
    onSelectContract(selected) {
      // console.log("Selected:", selected);

      this.selected_contract_number = selected.contract_number;

      this.model.invoice_contract_id = selected.contract_id;

      // // 🔥 set ke model
      this.model.contract_number = selected.contract_number;
      this.model.contract_value = selected.contract_total_amount;

      // // 🔥 auto fill client info (readonly display)
      this.model.clientName = selected.client_name;
      this.model.clientEmail = selected.client_email || "";
      this.model.clientPhoneNumber = selected.client_phone || "";
      this.model.clientAddress = selected.client_address || "";
      this.model.contract_value = selected.contract_total || 0;

      this.filter_date = [
        selected.contract_startdate,
        selected.contract_enddate,
      ];

      // // trigger mapping ke model
      this.FilterModelDate();
    },
    closeClient() {
      this.isEnablePopup = false;
    },
    openClientBrowser() {
      if (!this.model.id_branch || this.model.id_branch === "all") {
        alert("please choose Branch Station");
        return;
      }
      this.isEnablePopup = "client";
    },
    async applyClient(data) {
      //   console.log(data);
      this.isAutoloadMaps = false;
      this.model.id_client = data.id;
      this.model.name = data.name;
      this.model.email = data.email;
      this.model.phone_number = data.phone_number;
      this.model.id_propinsi = data.id_propinsi;
      this.model.id_kota = data.id_kota;
      this.provinces_name =
        data.nama_provinsi || data.provinces_name || this.provinces_name;
      if (!this.provinces_name && data.id_propinsi) {
        await this.loadProvinceName(data.id_propinsi);
      }

      this.markerCoordinates = {
        latitude: parseFloat(data.lat),
        longitude: parseFloat(data.lng),
        address: data.office_address,
      };
      setTimeout(() => {
        this.isAutoloadMaps = true;
      }, 200);
    },
    validationShiftNameHour() {
      let duplicateShiftNameHour = false;
      let model = this.sw.data;
      for (let key in model) {
        if (
          model[key].name.toLowerCase().trim() == this.sw.name.toLowerCase().trim()
        ) {
          duplicateShiftNameHour = true;
          break;
        }
      }

      return duplicateShiftNameHour;
    },
    AddShiftWork() {
      let model = this.sw.data;
      if (this.sw.name !== "" && this.sw.hour !== "" && this.sw.working_hours !== "") {
        this.sw.msg_error = "";
        console.log(this.validationShiftNameHour());
        if (model.length > 0) {
          if (!this.validationShiftNameHour()) {
            model.push({ name: this.sw.name, hour: this.sw.hour, working_hours: this.sw.working_hours });
          } else {
            this.sw.msg_error = "Failed, shift name must be unique !";
          }
        } else {
          model.push({ name: this.sw.name, hour: this.sw.hour, working_hours: this.sw.working_hours });
        }

        // model.push({ name: this.sw.name, hour: this.sw.hour });
        this.sw.name = "";
        this.sw.hour = "";
        this.sw.working_hours = 8;
      } else {
        this.sw.msg_error = "Please insert shift name, start hour, and working hours !";
      }
    },
    RemoveShiftWorker(idx) {
      let model = this.sw.data;
      model.splice(idx, 1);
    },
    isShiftNameUsed(name) {
      return this.sw.data.some(
        (shift) => shift.name.toLowerCase().trim() === name.toLowerCase().trim()
      );
    },
    SaveSectionRoom() {
      let data_section = this.data_section;
      for (let key in data_section) {
        var data_bind = data_section[key].data;
        if (data_bind.length > 0) {
          var temp_data = [];
          for (let items in data_bind) {
            if (data_section[key].data[items].area_name !== "") {
              temp_data.push(data_section[key].data[items]);
            } else {
              alert("Please entry completely all room name");
              return;
            }
          }

          if (data_section[key]) {
            data_section[key].data = temp_data;
          }
        }
      }

      const currentSection = this.data_section.find(
        (x) =>
          x.section ==
          (this.popup_mode == "insert"
            ? this.no_section
            : this.active_edit_section)
      );

      if (currentSection) {
        currentSection.category_type = this.category_type;
      }

      this.isEnablePopup = false;
    },
    AddMoreManPower() {
      let model = this.mp.data;
      this.mp.msg_error = "";
      if (this.mp.job !== "") {
        for (let key in model) {
          if (model[key].job == this.mp.job) {
            this.mp.msg_error = "Job position is already exists !";
            return;
          }
        }
        model.push({ total: this.mp.total, job: this.mp.job });
      } else {
        this.mp.msg_error = "Please choose job position !";
      }
    },
    RemoveManPower(idx) {
      let model = this.mp.data;
      model.splice(idx, 1);
    },
    AddMoreSection() {
      this.popup_mode = "insert";
      this.no_section = this.no_section + 1;
      this.category_type = "cleaning";
      this.active_edit_section = this.no_section;

      this.data_section.push({
        section: this.no_section,
        category_type: this.category_type,
        data: [
          {
            section: "",
            area_type: "indoor",
            area_task: "",
            area_name: "",
            area_floor: 1,
          },
        ],
      });

      window.scrollTo(500, 0);
      this.isEnablePopup = "section";
    },
    EditSection(no) {
      // this.popup_mode = "edit";
      // this.active_edit_section = no;

      // this.isEnablePopup = "section";

      const section = this.data_section.find((x) => x.section === no);

      if (section) {
        this.category_type = section.category_type;
      }

      this.isEnablePopup = "section";
    },
    DeleteSection(no) {
      if (confirm("Continue remove section #" + (no + 1))) {
        this.data_section.splice(no, 1);
      }
    },
    AddMoreSlotRoom() {
      let model = this.data_slot;
      let data_section = this.data_section;
      for (let idx in data_section) {
        if (data_section[idx].section == this.no_section) {
          data_section[idx].data.push({
            section: 1,
            area_type: "indoor",
            area_task: "",
            area_name: "",
            area_floor: 1,
          });
        }
      }

      $("#add-more-notify").text("1 slot unit is already created.");
      $("#add-more-notify").show();
      setTimeout(() => {
        $("#add-more-notify").fadeOut();
      }, 1000);
    },
    removeSlotRoom(idx) {
      this.data_slot.splice(idx, 1);
    },

    QueryJobPosition() {
      axios
        .post("job_position/data/all")
        .then((res) => {
          this.model_jobpos = res.data;
        })
        .finally(() => {});
    },
    async fetchKota() {
      this.model_kota = JSON.parse(localStorage.getItem("data_regencies"));
    },
    switchClientBase() {
      if (this.model.id_branch == undefined || this.model.id_branch == "") {
        alert("please choose Branch Station");
        this.isBaseClient = "new";
        return;
      }
      //   console.log(this.isBaseClient);
      if (this.isBaseClient == "new") {
        this.isAutoloadMaps = false;

        // reset default value model from old
        this.model.id_client = "";
        this.model.name = "";
        this.model.email = "";
        this.model.phone_number = "";

        this.model.id_kota = "";
        this.model.lat = "";
        this.model.lng = "";
        this.model.office_address = "";
        this.markerCoordinates = [];

        setTimeout(() => {
          this.isAutoloadMaps = true;
        }, 200);
      }
    },
    async submit(e) {
      e.preventDefault();

      this.model.isBaseClient = this.isBaseClient;
      this.model.man_power = this.mp.data;
      this.model.shift = this.sw.data;
      this.model.working_hours = this.sw.data.length
        ? this.sw.data[0].working_hours
        : this.model.working_hours;

      // rewrite data DOM  parsing to model
      const addressInput = document.getElementById("input_address");
      const latitudeInput = document.getElementById("input_lat");
      const longitudeInput = document.getElementById("input_lon");
      this.model.office_address = addressInput
        ? addressInput.value
        : this.model.office_address;
      this.model.lat = latitudeInput ? latitudeInput.value : this.model.lat;
      this.model.lng = longitudeInput ? longitudeInput.value : this.model.lng;
      this.model.data_slot = this.data_section;
      // this.model.contract_date = this.$moment(this.sdate).format("DD-MM-YYYY");
      this.model.contract_date = this.sdate;

      // start date and end date
      // var sdate = document.getElementById("startDate").value;
      // var edate = document.getElementById("endDate").value;
      // this.model.start_date =
      //   sdate == "" ? "" : this.$moment(sdate).format("DD-MM-YYYY");
      // this.model.end_date =
      //   edate == "" ? "" : this.$moment(edate).format("DD-MM-YYYY");

      this.$store.state.loading.msg = "Save Data...";
      this.$store.state.loading.status = true;

      let data = {
        url: this.meta_url + "/store",
        callback_url: "jobcon/contract-data",
        callback_query: this.contractListQuery(),
        form_data: this.model,
      };
      // console.log(JSON.stringify(data.form_data));
      await this.$store.dispatch("crud/storeData", data);
    },
    contractListQuery() {
      const query = Object.assign({}, this.$route.query);
      delete query.contract_id;
      return query;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.contract-create-page {
  color: #293b4f;
}
.contract-create-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 12px 28px rgba(20, 77, 126, 0.18);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
  min-height: 150px;
  overflow: hidden;
  padding: 28px 34px;
  position: relative;
}
.contract-create-hero::after {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
  height: 230px;
  position: absolute;
  right: -55px;
  top: -90px;
  width: 230px;
}
.contract-create-hero small {
  color: #8ff3e8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
}
.contract-create-hero h3 {
  color: #fff;
  font-size: 24px;
  margin: 5px 0 4px;
}
.contract-create-hero p {
  color: rgba(255, 255, 255, 0.88);
  margin: 0;
}
.contract-create-hero-icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 14px;
  display: flex;
  font-size: 34px;
  height: 72px;
  justify-content: center;
  position: relative;
  width: 72px;
  z-index: 1;
}
.contract-create-card {
  border: 1px solid #e3eaf1;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(33, 55, 79, 0.08);
  overflow: hidden;
}
.contract-create-card .card-body {
  padding: 0;
}
.contract-create-form > .contract-create-card::v-deep .form-control {
  border: 1px solid #d6e0e9;
  border-radius: 7px;
  min-height: 42px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.contract-create-form > .contract-create-card::v-deep .form-control:focus {
  border-color: #188ac2;
  box-shadow: 0 0 0 3px rgba(24, 138, 194, 0.12);
}
.contract-create-form .form-group {
  align-items: flex-start;
  display: flex;
  float: none;
  flex-wrap: wrap;
  margin: 0;
  padding: 10px 30px;
  width: 100%;
}
.contract-create-form .form-group > label {
  color: #45586d;
  font-size: 12px;
  font-weight: 600;
  padding-top: 11px;
}
.contract-create-form .form-group textarea.form-control {
  min-height: 90px;
}
.contract-create-form .contract-map-row > .col-sm-9 {
  background: #f8fafc;
  border: 1px solid #dfe7ef;
  border-radius: 10px;
  padding: 16px;
}
.contract-section-heading {
  background: linear-gradient(90deg, #f2f8fd 0%, #fbfdff 100%);
  border-bottom: 1px solid #e1eaf2;
  border-top: 1px solid #e1eaf2;
  margin-top: 20px !important;
  padding-bottom: 18px !important;
  padding-top: 18px !important;
}
.contract-section-heading:first-child {
  border-top: 0;
  margin-top: 0 !important;
}
.contract-section-heading label {
  color: #1e5f92 !important;
  display: block;
  font-size: 15px !important;
  font-weight: 700 !important;
  padding: 0 !important;
}
.contract-section-heading small {
  display: block;
  margin-top: 4px;
}
.contract-section-heading hr {
  display: none;
}
.contract-config-row {
  align-items: flex-start;
  background: #f9fbfd;
  border: 1px solid #e1e8ef;
  border-radius: 9px;
  display: flex;
  float: left;
  margin: 10px 30px 4px !important;
  padding: 18px 8px;
  width: calc(100% - 60px);
}
.contract-config-row .badge {
  border-radius: 999px;
  padding: 5px 8px;
}
.contract-config-row .btn-light {
  background: #fff;
  border: 1px solid #d7e1ea;
  border-radius: 7px;
  box-shadow: 0 3px 8px rgba(31, 67, 99, 0.06);
}
.contract-area-config > .row {
  width: 100%;
}
.contract-area-config h5 {
  color: #334b63;
  font-size: 13px;
}
.contract-create-form .list-section {
  background: #fff;
  border: 1px solid #e3e9ef;
  border-radius: 6px;
  color: #647486;
  margin-bottom: 6px;
  padding: 9px 11px;
}
.contract-create-actions {
  background: #fff;
  border: 1px solid #e3eaf1;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(33, 55, 79, 0.08);
  margin: 18px 0 36px;
  padding: 18px 22px;
}
.contract-create-actions .btn {
  border-radius: 7px;
  min-width: 140px;
  padding: 10px 18px;
}

.shift-hours-select {
  display: inline-block;
  margin: 0 8px;
  padding: 4px 8px;
  width: 105px;
}
.contract-create-modal {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  margin: 0;
  overflow-y: auto;
  padding: 24px;
  position: fixed;
  right: 0;
  top: 0 !important;
  width: 100vw;
  z-index: 1200;
}
.contract-create-modal::before {
  z-index: 0;
}
.contract-create-modal .content,
.contract-create-modal--client::v-deep .content {
  border-radius: 12px;
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.25);
  float: none;
  margin: auto;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  padding: 24px 28px;
  width: 100%;
}
.contract-create-modal--compact .content {
  max-width: 640px;
}
.contract-create-modal--shift .content {
  max-width: 760px;
}
.contract-create-modal--section .content {
  max-width: 900px;
}
.contract-create-modal--client::v-deep .content {
  max-width: 1180px;
}

@media (max-width: 767px) {
  .contract-create-hero {
    margin-bottom: 14px;
    min-height: 132px;
    padding: 22px 20px;
  }
  .contract-create-hero h3 {
    font-size: 20px;
  }
  .contract-create-hero p {
    font-size: 11px;
    max-width: 270px;
  }
  .contract-create-hero-icon {
    display: none;
  }
  .contract-create-form .form-group {
    display: block;
    padding: 9px 16px;
  }
  .contract-create-form .form-group > [class*="col-"] {
    float: none;
    padding-left: 0;
    padding-right: 0;
    width: 100%;
  }
  .contract-create-form .form-group > label {
    display: block;
    padding: 0 0 6px;
    width: 100%;
  }
  .contract-section-heading {
    padding: 16px !important;
  }
  .contract-config-row {
    display: block;
    margin: 10px 16px 4px !important;
    padding: 16px 6px;
    width: calc(100% - 32px);
  }
  .contract-config-row > [class*="col-"] {
    float: none;
    margin-bottom: 12px;
    width: 100%;
  }
  .contract-create-actions {
    margin: 14px 0 24px;
    padding: 14px;
  }
  .contract-create-actions .col-md-12 {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    padding: 0;
  }
  .contract-create-actions .btn {
    margin: 0 !important;
    text-align: center;
    width: 100%;
  }
  .contract-create-modal {
    align-items: flex-start;
    padding: 14px;
  }
  .contract-create-modal .content,
  .contract-create-modal--client::v-deep .content {
    margin: 0;
    max-height: calc(100vh - 28px);
    padding: 20px 16px;
  }
}
#add-more-notify {
  display: none;
}
.area-section {
  background-color: whitesmoke;
}
.list-data {
  position: relative;
  float: left;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  .ti {
    position: absolute;
    right: 10px;
    top: 15px;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
}

.list-section {
  width: 100%;
  float: left;
  // border-top: 1px solid whitesmoke;
  border-bottom: 1px solid whitesmoke;
  padding: 10px;
}

.invalid {
  border: 1px solid red;
}
// .valid {
//   border: 2px solid green;
// }
.invalid-warning {
  margin: 10px auto;
  color: red;
}

.contract-info-box {
  background: #f8f9fa;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 15px;
}

.info-item label {
  font-size: 12px;
  color: #888;
  margin-bottom: 2px;
}

.info-item .value {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  word-break: break-word;
}
</style>
